import styled from 'styled-components';
import C from 'assets/themes/colors';

interface IRootProps {
  backgroundColor?: string;
  hoverBackgroundColor?: string;
}

export const Root = styled.div``

export const FileContainer = styled.div`
  width: 100%;
  display: flex;
  height: 50px;
  align-items: center;
  border-bottom: 1px solid #dddddd;
  background-color: ${(props: IRootProps) => props.backgroundColor ? props.backgroundColor : C.WHITE};
  &:hover {
    background-color: ${C.GRAY};
  }
`

export const FileNameLabel = styled.div`
  width: calc(100% - 314px);
  margin: 0 29px 0px 29px;
  font-family: Roboto;
  font-size: 16px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8891a0;
  display: flex;
  align-items: center;
`

export const FileUploadLabel = styled.div`
  width: 85px;
  flex-grow: 0;
  margin: 0 0 0px;
  font-family: Roboto;
  font-size: 16px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  display: flex;
  justify-content: center;
`

export const FileTagLabel = styled.div`
  width: 70px;
  margin: 0 26px 0px 32px;
  font-family: Roboto;
  font-size: 16px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #8891a0;
`

export const CheckIcon = styled.div`
`

export const ErrorIconContainer = styled.div`
  display: flex;
  margin: 0px 0px 0px 5px;
`

export const RemoveIconContainer = styled.div`
  display: none;
  cursor: pointer;
  ${FileContainer}:hover & {
    display: block;
  }
`

export const RetryContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0px 0px 0px 0px;
`

export const RetryLabel = styled.div`
  width: 33px;
  flex-grow: 0;
  margin: 0px 0px 0px 2px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
  display: flex;
  align-items: center;
`
